import type { Ref } from 'react'

export type SearchPreviewState =
  | 'default'
  | 'hover'
  | 'focused'
  | 'filled'
  | 'disabled'
  | 'with-filter'

export const SEARCH_PREVIEW_STATES: SearchPreviewState[] = [
  'default',
  'hover',
  'focused',
  'filled',
  'disabled',
  'with-filter',
]

export const SEARCH_PREVIEW_STATE_LABELS: Record<SearchPreviewState, string> = {
  default: 'Default',
  hover: 'Hover',
  focused: 'Focused',
  filled: 'Filled',
  disabled: 'Disabled',
  'with-filter': 'With filter',
}

export const SEARCH_PREVIEW_PLACEHOLDER = 'Search'

export const SEARCH_PREVIEW_FILLED_VALUE = 'Search Text'

export type SearchProps = {
  value?: string
  defaultValue?: string
  placeholder?: string
  disabled?: boolean
  showFilter?: boolean
  /**
   * When true, the clear control can appear alongside the filter button
   * (used by SearchWithFilter). Default Search hides clear when filter is on.
   */
  allowClearWithFilter?: boolean
  /** Reflects filter menu open state on the filter trigger. */
  filterExpanded?: boolean
  /** Ref for the filter trigger (menu positioning). */
  filterButtonRef?: Ref<HTMLButtonElement>
  /** Dark theme surface. */
  darkMode?: boolean
  className?: string
  ariaLabel?: string
  /** Static visual state for the design-system showcase only. */
  previewState?: SearchPreviewState
  onChange?: (value: string) => void
  onClear?: () => void
  onFilterClick?: () => void
}
